import Modal from "../../../../conponents/modal/new";
import EmptyState from "../../../../conponents/emptyState/index.js";
import styles from "./ReceiptDialog.module.css";


const ReceiptDialog = ({

    open,

    receiptUrl,

    title = "فاکتور",

    onClose,

}) => {

    return (

        <Modal

            open={open}

            title={title}

            onClose={onClose}

            size="lg"

        >

            {

                receiptUrl

                    ?

                    <div className={styles.container}>

                        <img

                            src={receiptUrl}

                            alt="receipt"

                            className={styles.image}

                        />

                    </div>

                    :

                    <EmptyState

                        title="فاکتوری وجود ندارد"

                        description="برای این هزینه تصویری ثبت نشده است."

                    />

            }

        </Modal>

    );

};

export default ReceiptDialog;